import AiCallSummary from "@shared/AiAssistant/AiCallSummary";
import { useFeatureFlags } from "../../../reducers/layoutReducer/selectors";

const OUTCOMES = {
  Answered: (agentName) => (
    <span>
      Answered by <b>{agentName}</b>
    </span>
  ),
  Missed: () => <span>Missed Call</span>,
  Voicemail: () => <span>Voicemail</span>,
};

const TimelineTrackingNumberEvent = ({ event }) => {
  const featureFlags = useFeatureFlags();
  const firstName = event.timeline_fields.first_name || "";
  const lastName = event.timeline_fields.last_name || "";
  const name = `${firstName} ${lastName}`.trim();

  return (
    <div className="timeline-event !tw-cursor-default">
      <div className="row">
        <div className="col-xs-1">
          <i className="fa fa-phone timeline-icon-circle" />
        </div>
        <div className="col-xs-7">
          <span className="bold-detail">{name ? name : "No Name"}</span>
          {` called ${event.timeline_fields.tracking_number || "Tracking Number"}`}
          <div className="timeline-description-text">
            Call Type: Inbound Call to{" "}
            <span className="bold-detail">{event.timeline_fields.tracking_number_name}</span>
          </div>
          <div className="timeline-description-text">
            Call Result:{" "}
            <span className="tw-capitalize">
              {OUTCOMES[event.timeline_fields.outcome]?.(event.timeline_fields.answered_by)}
            </span>
          </div>
        </div>
        <div className="col-xs-1" />
        <div className="col-xs-3 time-ago">
          <span>{event.interacted_at_absolute}</span>
        </div>
      </div>
      {featureFlags.callRecording && event.timeline_fields.call_sid && (
        <div className="row">
          <AiCallSummary
            callSid={event.timeline_fields.call_sid}
            isCallRecordingEnabled
            aiSummaryDisabled={
              featureFlags.callRecordingAdjustments && event.timeline_fields.agent_ai_call_summary === false
            }
            showCallCoaching={featureFlags.aiCallAnalysis}
          />
        </div>
      )}
    </div>
  );
};

export default TimelineTrackingNumberEvent;
